import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

export const InfoIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path
            id="info-a"
            d="M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21.75 C17.3847763,21.75 21.75,17.3847763 21.75,12 C21.75,6.61522369 17.3847763,2.25 12,2.25 C6.61522369,2.25 2.25,6.61522369 2.25,12 C2.25,17.3847763 6.61522369,21.75 12,21.75 Z M12.25,6 C13.075,6 13.625,6.55 13.625,7.375 C13.625,8.2 13.075,8.75 12.25,8.75 C11.425,8.75 10.875,8.2 10.875,7.375 C10.875,6.55 11.425,6 12.25,6 Z M15,17 L9.5,17 L9.5,15.625 L10.875,15.625 L10.875,11.5 L9.5,11.5 L9.5,10.125 L13.625,10.125 L13.625,15.625 L15,15.625 L15,17 Z"
        />
    </SvgIcon>
);

export default InfoIcon;
